// Phase 1 configs — only compression, target-size, and use-case/optimization clusters

export interface TargetSizeConfig {
  size: string;
  slug: string;
  keyword: 'imagen' | 'foto';
}

export interface CompressionConfig {
  keyword: string;
  displayKeyword: string;
  slug: string;
}

export interface UseCaseConfig {
  useCase: string;
  context: string;
  slug: string;
  detailText: string;
  pageType: 'compression' | 'optimization';
}

// ─── Target-size: new sizes not already in manual tools ─────────────────────
export const phase1TargetSizeConfigs: TargetSizeConfig[] = [
  { size: '30KB', slug: 'reducir-imagen-30kb', keyword: 'imagen' },
  { size: '75KB', slug: 'reducir-imagen-75kb', keyword: 'imagen' },
  { size: '1MB', slug: 'reducir-imagen-1mb', keyword: 'imagen' },
  { size: '3MB', slug: 'reducir-imagen-3mb', keyword: 'imagen' },
  { size: '50KB', slug: 'reducir-foto-50kb', keyword: 'foto' },
  { size: '300KB', slug: 'reducir-foto-300kb', keyword: 'foto' },
  { size: '500KB', slug: 'reducir-foto-500kb', keyword: 'foto' },
];

// ─── Compression synonyms ───────────────────────────────────────────────────
export const phase1CompressionConfigs: CompressionConfig[] = [
  { keyword: 'fotos-online', displayKeyword: 'comprimir fotos online', slug: 'comprimir-fotos-online' },
  { keyword: 'imagen-gratis', displayKeyword: 'comprimir imagen gratis', slug: 'comprimir-imagen-gratis' },
  { keyword: 'reducir-peso', displayKeyword: 'reducir peso de imagen', slug: 'reducir-peso-imagen' },
  { keyword: 'foto-online', displayKeyword: 'comprimir foto online', slug: 'comprimir-foto-online' },
  { keyword: 'imagen-jpg', displayKeyword: 'comprimir imagen JPG', slug: 'comprimir-imagen-jpg' },
  { keyword: 'reducir-tamano', displayKeyword: 'reducir tamaño de imagen', slug: 'reducir-tamano-imagen' },
  { keyword: 'reducir-peso-foto', displayKeyword: 'reducir peso de foto', slug: 'reducir-peso-foto' },
];

// ─── Use-case / optimization pages ──────────────────────────────────────────
export const phase1UseCaseConfigs: UseCaseConfig[] = [
  {
    useCase: 'comprimir-whatsapp',
    context: 'WhatsApp',
    slug: 'comprimir-imagen-para-whatsapp',
    detailText: 'WhatsApp comprime automáticamente las imágenes que envías, reduciendo su calidad. Si comprimes tus fotos antes de enviarlas, puedes controlar la compresión y mantener una calidad superior.',
    pageType: 'compression',
  },
  {
    useCase: 'comprimir-cv',
    context: 'currículum vitae',
    slug: 'comprimir-imagen-para-cv',
    detailText: 'Los portales de empleo y sistemas de selección suelen limitar el tamaño de las fotos en los CV a 100KB-500KB. Comprime tu foto profesional para que cumpla con estos requisitos sin perder calidad.',
    pageType: 'compression',
  },
  {
    useCase: 'comprimir-web-gratis',
    context: 'web (gratis)',
    slug: 'comprimir-imagen-para-web-gratis',
    detailText: 'Las imágenes sin optimizar son la causa principal de sitios web lentos. Comprime tus fotos gratis para mejorar la velocidad de carga, el SEO y la experiencia del usuario.',
    pageType: 'optimization',
  },
  {
    useCase: 'optimizar-seo',
    context: 'SEO',
    slug: 'optimizar-imagen-seo',
    detailText: 'Google penaliza los sitios con imágenes pesadas. Optimiza tus imágenes para mejorar las métricas Core Web Vitals, reducir el LCP y posicionar mejor en los resultados de búsqueda.',
    pageType: 'optimization',
  },
  {
    useCase: 'optimizar-blog',
    context: 'blog',
    slug: 'optimizar-imagen-para-blog',
    detailText: 'Las imágenes de tu blog deben cargarse rápidamente para mantener a los lectores. Optimiza cada imagen antes de publicarla para lograr tiempos de carga mínimos y mejor posicionamiento orgánico.',
    pageType: 'optimization',
  },
];
